import { CheckCircle } from "lucide-react";
import { NextPage } from "next";

import { BluetoothPageMetadata } from "@components/bluetooth-landing/BluetoothPageMetadata";
import { ClientToaster } from "@components/bluetooth-landing/ClientToaster";
import { Hero, HeroCopy } from "@components/bluetooth-landing/Hero";
import { Navbar } from "@components/bluetooth-landing/Navbar";

const metadata = {
  title:
    "Specjaliści w Bluetooth Low Energy: firmware, aplikacje mobilne i PCB",
  description:
    "Jesteśmy specjalistami w Bluetooth Low Energy, firmware, aplikacjach mobilnych i PCB. Opracowujemy firmware na nRF52832, nRF52840, nRF5340 i nRF54. Budujemy aplikacje mobilne na iOS i Android z użyciem Flutter i wsparciem dla Bluetooth Low Energy.",
  canonicalPath: "/specjalisci-bluetooth-low-energy",
  lang: "pl" as const,
  ogLocale: "pl_PL",
  structuredData: [],
  alternatePaths: {
    pl: "/specjalisci-bluetooth-low-energy",
  },
};

export const heroCopy: HeroCopy = {
  header: "Specjaliści w",
  headerTail: "Bluetooth Low Energy",
  description:
    "Opracowujemy rozwiązania oparte na Bluetooth Low Energy. Projektujemy elektronikę, firmware oraz aplikacje mobilne. Skorzystaj z naszego wieloletniego doświadczenia.",
  cta: {
    text: "Darmowa konsultacja",
    href: "#kontakt",
  },
  secondaryCta: {
    text: "Poznaj nasz proces",
    href: "#proces",
  },
  benefits: [
    { text: "Polski zespół", Icon: CheckCircle },
    { text: "Gotowe na RODO i rynek UE", Icon: CheckCircle },
    { text: "Wsparcie przed i po premierze", Icon: CheckCircle },
  ],
};

const BluetoothLowEnergyPage: NextPage = () => {
  return (
    <div className="bluetooth-landing">
      <BluetoothPageMetadata {...metadata} />
      <ClientToaster />
      <Navbar />
      <main>
        <Hero copy={heroCopy} />
      </main>
    </div>
  );
};

export default BluetoothLowEnergyPage;
